import { createContext, useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";

// Stand-in for useBlocker/usePrompt, which need a data router this app
// (plain BrowserRouter) doesn't use. Holds one active guard function
// `(to, state) => void`, set via useSetNavigationGuard and consulted by
// useGuardedNavigate.
export const NavigationGuardContext = createContext(null);

// Always call from a useEffect (activate on mount, setGuard(null) on
// cleanup) so a step change or unmount can't leave a stale guard behind.
export const useSetNavigationGuard = () => {
  const guardRef = useContext(NavigationGuardContext);
  return useCallback(
    (onIntercept) => {
      if (guardRef) guardRef.current = onIntercept;
    },
    [guardRef]
  );
};

/** Drop-in replacement for react-router's useNavigate() that honours an active guard. */
export const useGuardedNavigate = () => {
  const navigate = useNavigate();
  const guard = useContext(NavigationGuardContext);
  return useCallback(
    (to, options) => {
      if (guard?.current) {
        guard.current(to, options?.state);
        return;
      }
      navigate(to, options);
    },
    [navigate, guard]
  );
};
